<template>
    <div class="group-items-editor" style="width: 100%;">
        <div style="text-align: right; margin-bottom: 12px;">
            <el-button type="primary" @click="onAdd(null)" v-if="enableAddGroup">新增群組</el-button>
        </div>
        <div style="width: 100%; overflow-x: auto; padding-bottom: 50px;" ref="scrollview">
            <draggable v-model="inputValue" draggable=".group-draggable" handle=".group-name" animation="300" @end="onGroupDragEnd" :style="{ width: 250 * (inputValue.length + 1) + 'px' }">
                <div :class="{ group: true, 'group-draggable': group.draggable, disabled: !group.editable }" v-for="group in inputValue" :key="group.sno">
                    <div class="group-header">
                        <div class="group-name">
                            <span class="edit-btn" @click="onGroupEdit(group)">{{ group.name ? group.name : "（未命名）" }}</span>
                        </div>
                        <div class="actions" v-if="group.addChild">
                            <span class="add-btn" @click="onAdd(group)"></span>
                        </div>
                    </div>
                    <div class="group-items">
                        <draggable v-model="group.children" draggable=".item-draggable" handle=".item-name" animation="300" @end="onItemDragEnd(group.children)">
                            <div v-for="item in group.children" :key="item.sno" :class="{ item: true, 'item-draggable': item.draggable, disabled: !item.editable }">
                                <div class="item-name">
                                    <span class="edit-btn" @click="onItemEdit(item, group)">{{ item.name ? item.name : "（未命名）" }}</span>
                                </div>
                            </div>
                            <div class="bottom-add-btn" @click="onAdd(group)" v-if="group.addChild">新增子項目</div>
                        </draggable>
                    </div>
                </div>
            </draggable>
        </div>
        <el-dialog :visible="itemEditor.visible" class="small-edit-dialog" width="400px" @close="onItemEditorClose" @opened="onEditDialogOpened">
            <div class="title">
                <span>{{ itemEditor.sno !== null ? "編輯" : "新增" }}</span>
                <span>{{ itemEditor.parent !== null ? "子項目" : "群組" }}</span>
            </div>
            <div style="margin-bottom: 20px;">
                <el-input v-model.trim="itemEditor.name" ref="itemEditorInput" :maxlength="20" :show-word-limit="true" @keyup.enter.native="onEditDialogPressEnter" />
            </div>
            <div class="main-action" style="text-align: right;">
                <el-button type="primary" class="primary-action" @click="onItemEditorClose(true)">
                    <span v-if="itemEditor.sno !== null">儲存變更</span>
                    <span v-else>新增</span>
                </el-button>
                <el-button @click="onItemEditorClose(false)">取消</el-button>
                <el-button v-if="itemEditor.sno !== null" @click="onItemEditorDelete">刪除</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import draggable from 'vuedraggable';

export default {
    name: 'group-item-editor',
    components: {
        draggable,
    },
    props: {
        value: {
            type: Array,
            default: null,
        },
        enableAddGroup: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            itemEditor: {
                visible: false,
                sno: null,
                name: '',
                target: null,
                parent: null,
            },
        };
    },
    computed: {
        inputValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
    },
    created() {
        this.$emit('fetch');
    },
    methods: {
        onGroupDragEnd() {
            const items = [];
            this.inputValue.forEach((group, index) => {
                items.push({
                    sno: group.sno,
                    sot: index,
                });
            });

            this.$emit('sortUpdate', items);
        },
        onItemDragEnd(children) {
            const items = [];
            children.forEach((item, index) => {
                items.push({
                    sno: item.sno,
                    sot: index,
                });
            });
            this.$emit('sortUpdate', items);
        },
        onGroupEdit(group) {
            if (!group.editable) return;

            this.itemEditor.sno = group.sno;
            this.itemEditor.name = group.name;
            this.itemEditor.visible = true;
            this.itemEditor.target = group;
            this.itemEditor.parent = null;
        },
        onItemEdit(item, group) {
            if (!item.editable) return;

            this.itemEditor.sno = item.sno;
            this.itemEditor.name = item.name;
            this.itemEditor.visible = true;
            this.itemEditor.target = item;
            this.itemEditor.parent = group;
        },
        onItemEditorClose(save) {
            if (save) {
                if (this.itemEditor.name == '') {
                    this.$message({
                        showClose: true,
                        message: '請輸入名稱',
                        type: 'error',
                    });
                    this.$refs.itemEditorInput.focus();
                    return;
                }

                // edit
                if (this.itemEditor.sno) {
                    this.itemEditor.target.name = this.itemEditor.name;

                    this.$emit('itemEdit', {
                        sno: this.itemEditor.sno,
                        name: this.itemEditor.name,
                    });
                }

                // add
                if (this.itemEditor.sno === null) {
                    this.$emit('itemAdd', {
                        sno: this.itemEditor.sno,
                        name: this.itemEditor.name,
                        parent: this.itemEditor.parent ? this.itemEditor.parent.sno : null,
                    });
                }
            }

            this.itemEditor.visible = false;
        },
        onItemEditorDelete() {
            this.$confirm('確定要刪除？', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
            }).then(() => {
                this.$emit('itemDelete', {
                    sno: this.itemEditor.sno,
                });
            });
            this.itemEditor.visible = false;
        },
        onAdd(parent) {
            this.itemEditor.sno = null;
            this.itemEditor.name = '';
            this.itemEditor.visible = true;
            this.itemEditor.target = null;
            this.itemEditor.parent = parent;

            if (parent == null) {
                setTimeout(() => {
                    // this.$refs.scrollview.scrollLeft += 500
                    this.$refs.scrollview.scrollTo({ behavior: 'smooth', left: this.$refs.scrollview.scrollLeft + 500 });
                }, 10);
            }
        },

        onEditDialogOpened() {
            this.$refs.itemEditorInput.focus();
        },

        onEditDialogPressEnter(event) {
            this.onItemEditorClose(true);
            event.stopPropagation();
            event.preventDefault();
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.group-items-editor {
    $border-color: #d4d4d4;

    .group {
        display: inline-block;
        border: 1px solid $border-color;
        background-color: #f6f6f6;
        border-radius: 5px;
        vertical-align: top;
        width: 240px;
        margin: 0 5px;

        &.disabled {
            .group-header {
                .group-name {
                    color: #888;

                    .edit-btn {
                        cursor: not-allowed;

                        &:hover {
                            color: #888;
                        }
                    }
                }
            }
        }

        .group-header {
            position: relative;
            border-bottom: 1px solid $border-color;

            .group-name {
                width: calc(100% - 38px);
                line-height: 40px;
                padding: 0 15px;
                font-size: 12pt;
                font-weight: bold;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;

                .edit-btn {
                    cursor: pointer;

                    &:hover {
                        color: $main-color;
                    }
                }
            }

            .actions {
                position: absolute;
                top: 0;
                right: 0;
                padding: 6px 6px 0 0;
                z-index: 1;

                .add-btn {
                    position: relative;
                    text-align: center;
                    width: 28px;
                    height: 28px;
                    display: inline-block;
                    border: 1px solid #ccc;
                    border-radius: 4px;
                    line-height: 28px;
                    font-size: 9pt;
                    background-color: #f8f8f8;

                    &:after,
                    &:before {
                        position: absolute;
                        top: calc((26px - 2px) / 2);
                        left: calc((26px - 10px) / 2);
                        content: "";
                        display: block;
                        width: 10px;
                        height: 2px;
                        background-color: #aaa;
                    }

                    &:after {
                        transform: rotate(90deg);
                    }

                    &:hover {
                        cursor: pointer;
                        background-color: #fefefe;
                    }
                }
            }
        }

        .group-items {
            padding: 5px;

            .item {
                position: relative;
                background-color: #fff;
                border: 1px solid #ddd;
                margin: 0 0 5px 0;
                border-radius: 5px;

                &.disabled {
                    .item-name {
                        color: #888;

                        .edit-btn {
                            cursor: not-allowed;

                            &:hover {
                                color: #888;
                            }
                        }
                    }
                }

                .item-name {
                    width: 100%;
                    line-height: 34px;
                    padding: 0 12px;
                    font-size: 11pt;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;

                    .edit-btn {
                        cursor: pointer;

                        &:hover {
                            cursor: pointer;
                            color: $main-color;
                        }
                    }
                }

                .actions {
                    display: none;
                    position: absolute;
                    width: 38px;
                    height: 30px;
                    top: 0;
                    right: 2px;
                    padding: 4px 0 0 0;

                    .btn {
                        line-height: 24px;
                        border-radius: 3px;
                        display: inline-block;
                        border: 1px solid #453bb144;
                        padding: 0 5px;
                        font-size: 9pt;
                        color: #453bb1;
                        background-color: #453bb111;
                    }
                }
            }
        }

        .bottom-add-btn {
            position: relative;
            font-size: 9.5pt;
            display: inline-block;
            line-height: 26px;
            padding: 0 10px 0 28px;
            border-radius: 4px;
            color: #aaa;
            cursor: pointer;

            &:after,
            &:before {
                position: absolute;
                top: calc((26px - 2px) / 2);
                left: calc((26px - 10px) / 2);
                content: "";
                display: block;
                width: 10px;
                height: 2px;
                background-color: #aaa;
            }

            &:after {
                transform: rotate(90deg);
            }

            &:hover {
                color: $main-color;
                font-weight: bold;

                &:after,
                &:before {
                    background-color: $main-color;
                }
            }
        }
    }
}
</style>
